import type { BookingLinkProps } from "@studiolite/booking";
import { followWidgetHref } from "./widget-hrefs";

/**
 * Le `Link` des composants partages, cote widget. Sur le site du studio c'est
 * next/link ; ici tout reste dans l'iframe : les liens internes sont des
 * ancres ("#week=2026-11-09") que l'on traduit en changement d'etat.
 */
export function WidgetLink({ href, onClick, ...props }: BookingLinkProps) {
  // `scroll` sert a next/link ; sur une <a> ce serait un attribut inconnu.
  const { scroll, ...anchorProps } = props;
  void scroll;

  return (
    <a
      href={href}
      {...anchorProps}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        followWidgetHref(href);
      }}
    />
  );
}
